/* eslint-disable class-methods-use-this */
const convertWeight = require('../../helpers/weightConverter');
const convertVolume = require('../../helpers/volumeConverter');
const { freightUnit } = require('../../constants/payments');
const { orderType: OrderType, sourceAndDestinationType, chargeCode } = require('pando-constants');
const Helper = require('./utils/helper');

class Unloading {
  calaculateQuantity(materialList, unitType, materialMap, quantityUnitsForPieces) {
    let resultQuantity = 0;
    if (materialList && materialList.length) {
      switch (unitType) {
        case freightUnit.per_ton: {
          resultQuantity = materialList.map(material => convertWeight(material.weightUnit, 't', material.weight))
            .reduce((acc, weight) => acc + weight, 0);
          break;
        }
        case freightUnit.per_kg: {
          resultQuantity = materialList.map(material => convertWeight(material.weightUnit, 'kg', material.weight))
            .reduce((acc, weight) => acc + weight, 0);
          break;
        }
        case freightUnit.per_cft: {
          resultQuantity = materialList.map(material => convertVolume(material.volumeUnit, 'cft', material.volume))
            .reduce((acc, volume) => acc + volume, 0);
          break;
        }
        case freightUnit.per_package:
        case freightUnit.per_case:
        case freightUnit.per_box: {
          resultQuantity = materialList.map((material) => {
            const quantity = (material.quantity) ? Math.ceil(material.quantity) : 0;
            if (quantityUnitsForPieces[material.quantityUnit.toLowerCase()]) {
              const materialDetail = materialMap[material.materialCode];
              return (materialDetail.pce_box) ?
                Math.ceil(quantity / Math.ceil(materialDetail.pce_box)) : 0;
            }
            return quantity;
          }).reduce((acc, quantity) => acc + quantity, 0);
          break;
        }
        default:
          resultQuantity = 0;
          break;
      }
    }
    return resultQuantity;
  }
  getMaxChargeOfConsigneeGroup(_group, consigneeGroup, amount) {
    let charge = 0;
    const group = _group;
    if (!group[consigneeGroup]) {
      group[consigneeGroup] = 0;
    }
    if (amount > group[consigneeGroup]) {
      charge = (amount - group[consigneeGroup]);
      group[consigneeGroup] = amount;
    }
    return charge;
  }
  unloadingBasedOnDepotCharges(data, depotConfiguration, useDestinationCharges) {
    const quantityUnitsForPieces = Helper
      .getQuantityUnitsForPieces(data.customQuantityUnits);
    let result = 0;

    if (data.orderType === OrderType.OPEN && !(depotConfiguration
      && depotConfiguration.open_indents_charge
      && depotConfiguration.open_indents_charge.unloading_charge)) {
      return result;
    }

    const unloadingCostMap = {};
    let consigneeCharge = 0;
    const materialMap = Helper.fetchMaterialMap(data.materials.masterData);

    const unloadindCharges = data.indentDestinationCharges.filter(charge =>
      charge.charge_code === chargeCode.UNLOADING);
    const masterDepot = data.routeDetails && data.routeDetails.depot_id;
    // destination wise charge data calculation
    data.destinations.forEach((destination) => {
      const depotId = masterDepot || destination.locationId;
      const shouldUseDestinationCharge = (destination.type === sourceAndDestinationType.CONSIGNEE) ||
        (useDestinationCharges && destination.type === sourceAndDestinationType.DEPOT);
      if (shouldUseDestinationCharge) {
        const destinationCharge = unloadindCharges.find(charge =>
          charge.destination_id.toString() === destination.locationId.toString());
        if (destinationCharge) {
          const [contractCharge] = destinationCharge.charges;
          if (contractCharge) {
            const unloadingCost = contractCharge.charge;
            const minimumCharge = contractCharge.min_charge;
            const amount = (contractCharge.charge_unit === freightUnit.per_trip) ? unloadingCost
              : (this.calaculateQuantity(Helper.getNormalizedMaterialDetails(destination.materials),
                contractCharge.charge_unit, materialMap, quantityUnitsForPieces) * unloadingCost);
            consigneeCharge += Math.max(amount, minimumCharge);
            return; // Exit early, don't process master charges
          }
        }
      }
      this.processUnloadingCostMaster(data, depotId, destination, materialMap, quantityUnitsForPieces, unloadingCostMap);
    });
    let depotCharge = 0;
    if (unloadingCostMap[freightUnit.per_trip]) {
      depotCharge = unloadingCostMap[freightUnit.per_trip].toFixed(2);
    } else {
      const unloadingCharges = Object.values(unloadingCostMap);
      if (unloadingCharges.length) {
        const unloadingCharge = Math.max(...unloadingCharges);
        depotCharge = unloadingCharge.toFixed(2);
      }
    }
    result = Number(depotCharge) + Number(consigneeCharge.toFixed(2));
    return result;
  }

  // Add this helper method to the class:
  processUnloadingCostMaster(data, depotId, destination, materialMap, quantityUnitsForPieces, unloadingCostMap) {
    const unloadingCostMaster = data.unloadingChargesMaster[depotId];

    if (unloadingCostMaster) {
      const unitType = unloadingCostMaster.unit;
      if (!unloadingCostMap[unitType]) {
        unloadingCostMap[unitType] = 0;
      }
      const unloadingCost = unloadingCostMaster.unloadingCost;
      if (unitType === freightUnit.per_trip) {
        unloadingCostMap[unitType] = Math.max(unloadingCostMap[unitType], unloadingCost);
      } else {
        const amount = this.calaculateQuantity(Helper.getNormalizedMaterialDetails(
          destination.materials), unitType, materialMap, quantityUnitsForPieces) *
      (unloadingCost || 0);
        unloadingCostMap[unitType] += amount;
      }
    }
  }
}

module.exports = Unloading;
